package ru.villawonka.app.data.repository

import ru.villawonka.app.common.utils.Either
import ru.villawonka.app.common.utils.map
import ru.villawonka.app.data.entity.request.toSearchAccommodationRequest
import ru.villawonka.app.data.entity.response.toDomain
import ru.villawonka.app.data.source.PostsApi
import ru.villawonka.app.data.utils.networkRequest
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.domain.model.PaginatedResult
import ru.villawonka.app.domain.model.PostDomain
import ru.villawonka.app.domain.model.SearchParamsDomain
import ru.villawonka.app.domain.model.SortTypeDomain
import ru.villawonka.app.domain.repository.PostsRepository

class PostsRepositoryImpl(private val postsApi: PostsApi) : PostsRepository {

    override suspend fun searchByFilter(
        searchParams: SearchParamsDomain,
        sortType: SortTypeDomain,
        pageSize: Int,
        page: Int,
    ): Either<NetworkFailure, PaginatedResult<PostDomain.Accommodation>> = networkRequest {
        postsApi.searchAccommodation(searchParams.toSearchAccommodationRequest(
            page = page,
            pageSize = pageSize,
            sortType = sortType
        ))
    }.map { response ->
        PaginatedResult(
            totalCount = response.totalCount,
            currentPage = response.currentPage,
            pageSize = response.pageSize,
            hasNext = response.hasNext,
            data = response.data.map { it.toDomain() }
        )
    }

    override suspend fun requestFavoriteAccommodationPosts(): Either<NetworkFailure, List<PostDomain.Accommodation>> =
        networkRequest {
            postsApi.requestFavoriteAccommodationPosts()
        }.map { response ->
            response.map { it.toDomain() }
        }

    override suspend fun requestAccommodationPostById(
        postId: Int
    ): Either<NetworkFailure, PostDomain.Accommodation> = networkRequest {
        postsApi.requestAccommodationPostById(postId)
    }.map { it.toDomain() }

    override suspend fun likeAccommodationPost(postId: Int): Either<NetworkFailure, Unit> =
        networkRequest { postsApi.likeAccommodationPost(postId) }

    override suspend fun dislikeAccommodationPost(postId: Int): Either<NetworkFailure, Unit> =
        networkRequest { postsApi.dislikeAccommodationPost(postId) }
}